import dayjs from "dayjs";
import useEvents from "src/features/events/hooks/useEvents";
import projectOptions from "src/shared/project-options";
import { store } from "src/shared/store";
import { VideoType } from "../model/video-type";

export function useIsVideo() {
  const { data } = useEvents();
  const { end_date: stream_end_date } = data;
  return () => {
    // @ts-ignore
    const { videoType, showVideo, showVideoUntil } =
      projectOptions.default.options;
    let isVideo = videoType === VideoType.Video;
    if (!isVideo || !showVideo) {
      return false;
    }

    if (!stream_end_date || !showVideoUntil) {
      return false;
    }

    const streamEndDate = dayjs(stream_end_date);
    const videoEndDate = dayjs(showVideoUntil);

    if (dayjs().isAfter(streamEndDate) && dayjs().isBefore(videoEndDate)) {
      return true;
    } else {
      return false;
    }
  };
}

export default function getIsVideo() {
  // @ts-ignore
  const { end_date: stream_end_date } = store.getState().events.data || {};
  const { videoType, showVideo, showVideoUntil } =
    projectOptions.default.options;
  let isVideo = videoType === VideoType.Video;
  if (!isVideo || !showVideo) {
    return false;
  }

  if (!stream_end_date || !showVideoUntil) {
    return false;
  }

  const streamEndDate = dayjs(stream_end_date);
  const videoEndDate = dayjs(showVideoUntil);

  if (dayjs().isAfter(streamEndDate) && dayjs().isBefore(videoEndDate)) {
    return true;
  } else {
    return false;
  }
}
